export default __webpack_public_path__ + "static/media/salesagent.168c38b0.jpg";